module.exports = __webpack_public_path__ + "static/linkedlist-2.3-5d2d38b04b86c8c9fba9b59b82cd4323.png";